import { useQuery } from "@apollo/client";
import React, { useContext } from "react";
import { GetAppAnonymousDocument } from "../gql/graphql";
const initialContext = {};
const AppContext = /*#__PURE__*/React.createContext(initialContext);
const useApp = () => useContext(AppContext);
const NblocksAppContextProvider = ({
  children
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GetAppAnonymousDocument);
  return /*#__PURE__*/React.createElement(AppContext.Provider, {
    value: {
      ...initialContext,
      ...data?.getAppAnonymous
    }
  }, children);
};
export { NblocksAppContextProvider, useApp };